export const columns = [
  {
    title: "Référence",
    dataIndex: "reference",
    key: "reference",
    sorter: (a, b) => a.reference.localeCompare(b.reference),
    width: 120,
  },
  {
    title: "Propriétaire",
    dataIndex: "owner",
    key: "owner",
    width: 190,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: 90,
  },
  {
    title: "Nuits confiées",
    dataIndex: "assigned",
    key: "assigned",
    align: "right",
    width: 125,
  },
  {
    title: "Nuits louées",
    dataIndex: "rented",
    key: "rented",
    align: "right",
    width: 120,
  },
  {
    title: "Occupation",
    dataIndex: "occupation",
    align: "right",
    key: "occupation",
    render: (occupation) => <>{occupation}%</>,
    width: 110,
  },
  {
    title: "Nbr de locations",
    dataIndex: "number",
    key: "number",
    align: "right",
    width: 100,
  },
  {
    title: "Durée moyenne",
    dataIndex: "duration",
    key: "duration",
    align: "right",
    width: 140,
  },
  {
    title: "Adultes",
    dataIndex: "percent_adult",
    key: "percent_adult",
    align: "right",
    render: (percent_adult) => <>{percent_adult}%</>,
    width: 90,
  },
  {
    title: "Enfants/bébés",
    dataIndex: "percent_children",
    align: "right",
    key: "percent_children",
    render: (percent_children) => <>{percent_children}%</>,
    width: 90,
  },
  {
    title: "C.A. Props",
    dataIndex: "total_ca",
    align: "right",
    key: "total_ca",
    render: (total_ca) =>
      parseFloat(total_ca).toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
      }),
    width: 120,
  },
  {
    title: "Taux Hono.",
    dataIndex: "rate_fee",
    align: "right",
    key: "rate_fee",
    render: (rate_fee) => <>{rate_fee}%</>,
    width: 120,
  },
  {
    title: "Hono. Agence",
    dataIndex: "owner_fee",
    align: "right",
    key: "owner_fee",
    render: (owner_fee) =>
      parseFloat(owner_fee).toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
      }),
    width: 120,
  },
  {
    title: "Hono. autres",
    dataIndex: "agency_fee",
    align: "right",
    key: "agency_fee",
    render: (agency_fee) =>
      parseFloat(agency_fee).toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
      }),
    width: 120,
  },
  {
    title: "Total Hono.",
    dataIndex: "fees",
    align: "right",
    key: "fees",
    render: (fees) =>
      parseFloat(fees).toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
      }),
    width: 120,
  },
];
